var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "dropdown",
    class: _setup.dropdownClasses,
    attrs: {
      "data-uid": _setup.uid,
      "data-flip": "true"
    }
  }, [_vm._t("activator", null, null, {
    on: _setup.on,
    attrs: _setup.attrs,
    opened: _setup.opened
  }), _c('div', {
    ref: "menuEl",
    staticClass: "dropdown-menu py-0 my-0",
    style: _setup.menuStyles
  }, [_c('div', {
    ref: "overflowEl",
    style: _setup.sheetStyles
  }, [_vm._t("default", function () {
    return [_vm._v("test")];
  }, null, {
    toggleMenu: _setup.toggleMenu,
    opened: _setup.opened
  })], 2)])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };